
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/album/[albumId]",
      function () {
        return require("private-next-pages/d/album/[albumId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/album/[albumId]"])
      });
    }
  